import { render, staticRenderFns } from "./editorCalendar.vue?vue&type=template&id=e357a2c6&scoped=true&"
import script from "./editorCalendar.vue?vue&type=script&lang=js&"
export * from "./editorCalendar.vue?vue&type=script&lang=js&"
import style0 from "./editorCalendar.vue?vue&type=style&index=0&id=e357a2c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e357a2c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
